// extracted by mini-css-extract-plugin
module.exports = {"highlight":"styles_highlight__1slLZ"};